import Action from "../actions";

export default function serviceReducer(state = {
    shorteningUrlService: {
        isValid: true,
        data: null
    },
    SKUService: {
        isValid: true,
        data: null
    }
}, action) {
    if (action.type === Action.SET_SERVICE_STATE) {
        return action.data;
    }
    return state;
}
